import { createAuthClient } from "better-auth/react";
import {
  emailOTPClient,
  inferAdditionalFields,
  jwtClient,
  organizationClient,
} from "better-auth/client/plugins";
import { env } from "../env/runtime";
import { AUTH_API_BASE } from "./auth-api-base";
import { createAuthPublicClient } from "./rpc/auth-public";

export const authPublicClient = createAuthPublicClient(AUTH_API_BASE);

// Identity/session operations stay central. Regional API calls use short-lived service JWTs.
export const authClient = createAuthClient({
  ...(env.VITE_AUTH_URL ? { baseURL: env.VITE_AUTH_URL } : {}),
  basePath: "/api/auth",
  plugins: [
    jwtClient(),
    organizationClient(),
    // Sign-up sends a six-digit code and returns no session; this is how the verify screen
    // spends it. Only two of the plugin's endpoints are reachable — the auth service denies
    // the rest, `/sign-in/email-otp` included.
    emailOTPClient(),
    // Browser-only field metadata; the auth service validates and persists the selection.
    inferAdditionalFields({
      user: {
        dataResidencyCountry: { type: ["US"], required: true, defaultValue: "US" },
      },
    }),
  ],
  fetchOptions: { credentials: "include", timeout: 10000 },
});
